import React, { useState } from "react";
import {
  Alert,
  Button,
  Drawer,
  FormFieldSet,
  Modal,
} from "../../../../components";
import { div } from "framer-motion/client";

const ModalItems = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isOpenModal2, setIsOpenModal2] = useState(false);
  const [isOpenDrawer2, setIsOpenDrawer2] = useState(false);
  const [isShowAlert2, setIsShowAlert2] = useState(false);
  const [isOpenDrawer3, setIsOpenDrawer3] = useState(false);
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        <Button title={"Open Modal"} onClick={() => setIsOpenModal(true)} />
        <Button title={"Open Drawer"} onClick={() => setIsOpenDrawer(true)} />
        <Button title={"Show Alert"} onClick={() => setIsShowAlert(true)} />
      </div>

      <div className="flex flex-wrap gap-2">
        <Button title={"Open Modal"} onClick={() => setIsOpenModal2(true)} />
        <Button title={"Open Drawer"} onClick={() => setIsOpenDrawer2(true)} />
        <Button title={"Show Alert"} onClick={() => setIsShowAlert2(true)} />
      </div>

      <div>
        <Button
          title={"Open Drawer updated"}
          onClick={() => setIsOpenDrawer3(true)}
        />
      </div>

      <Modal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        title="Modal Title"
        width="max-w-4xl"
      >
        <div>
          <FormFieldSet type="datepicker" />
        </div>
      </Modal>

      <Drawer
        isOpen={isOpenDrawer}
        onClose={() => setIsOpenDrawer(false)}
        position="right" // 'left', 'right', 'top', 'bottom'
        width="w-[50%]" // custom width using Tailwind classes
        title="Drawer Title"
      >
        <div>Drawer content here</div>
      </Drawer>

      <Alert
        isOpen={isShowAlert}
        onClose={() => setIsShowAlert(false)}
        title="Delete Item"
        description="Are you sure you want to delete this item? This action cannot be undone."
        cancelButton={{
          show: true,
          title: "Cancel",
          onClick: () => console.log("Cancelled"),
        }}
        acceptButton={{
          show: true,
          title: "Delete",
          onClick: () => console.log("Delete"),
        }}
      />

      <Modal
        isOpen={isOpenModal2}
        onClose={() => setIsOpenModal2(false)}
        title="Modal Title"
        width="max-w-4xl"
        closeOnOutsideClick
      >
        <div>Modal Close Click outside</div>
      </Modal>

      <Drawer
        isOpen={isOpenDrawer2}
        onClose={() => setIsOpenDrawer2(false)}
        position="right" // 'left', 'right', 'top', 'bottom'
        width="w-[50%]" // custom width using Tailwind classes
        title="Drawer Title"
        closeOnOutsideClick
      >
        <div>Drawer Close Click outside</div>
      </Drawer>

      <Alert
        isOpen={isShowAlert2}
        onClose={() => setIsShowAlert2(false)}
        closeOnOutsideClick
        title="Alert"
        description="Close Click outside"
        // description={
        //   <div>
        //     <h1>djlkdsj;fj;sjfj;</h1>
        //     <div>dfjs;ldfj;sldfj;lskjdf;sldjf;lskjf;jlsj</div>
        //   </div>
        // }
        cancelButton={{
          show: true,
          title: "Cancel",
          onClick: () => console.log("Cancelled"),
        }}
        acceptButton={{
          show: true,
          title: "Delete",
          onClick: () => console.log("Delete"),
        }}
      />

      <Drawer
        isOpen={isOpenDrawer3}
        onClose={() => setIsOpenDrawer3(false)}
        position="right" // 'left', 'right', 'top', 'bottom'
        width="w-[50%]" // custom width using Tailwind classes
        //title="Drawer Title"
        bodyGap={false}
        showCloseButton={false}
        closeOnOutsideClick={true}
      >
        <div>Drawer content here</div>
      </Drawer>
    </div>
  );
};

export default ModalItems;
